import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconChevronLeftOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M9 15.996c0 .26.1.52.3.7l11.98 11.98c.4.4 1.02.4 1.42 0s.4-1.02 0-1.42l-11.26-11.26 11.24-11.28c.4-.38.4-1.02 0-1.4s-1.02-.4-1.4 0L9.3 15.296c-.2.2-.3.46-.3.7" /></svg>;
export default SvgIconChevronLeftOutlined;